import React from 'react';

import { ModalFilter } from '../types';

interface Props {
  filters: Array<ModalFilter | null>;
}

const FilterList = ({ filters }: Props): any => {
  // filter out filters for only those that aren't `null`
  const prunedFilters = filters.filter((filter) => filter);

  if (prunedFilters.length < 1) return <div className="text-xs font-nunitoLight text-filterList m-0">Global View</div>;

  const filterTextStyles = 'font-nunitoLight m-0 text-xs mr-[5px]';
  return prunedFilters.map((filter, index) => {
    if (filter && filter?.values && filter?.values?.length) {
      return (
        <div className="inline-block" key={index}>
          <div className="flex items-center">
            <p className={filterTextStyles}>{filter?.name}:</p>
            <p className={`${filterTextStyles} font-bold font-nunitoMedium`}>
              {filter?.values.map((value, index) => {
                return `${value.name}${index !== filter.values.length - 1 ? ', ' : ' '}`;
              })}
            </p>
            {index !== prunedFilters.length - 1 && <span className="text-xs mr-[5px]"> / </span>}
          </div>
        </div>
      );
    }
  });
};

export default FilterList;
